import logo from "./assets/logo/logo.jpg";
import bannserImg from "./assets/banners/heroBanner.png";
import featureImg1 from "./assets/card/feature-img-1.png";
import featureImg2 from "./assets/card/feature-img-2.png";
import featureImg3 from "./assets/card/feature-img-3.png";
import client_1 from "./assets/client/client-1.png";
import client_2 from "./assets/client/client-2.png";
import client_3 from "./assets/client/client-3.png";
import client_4 from "./assets/client/client-4.png";
import client_5 from "./assets/client/client-5.png";
import client_6 from "./assets/client/client-6.png";
import client_7 from "./assets/client/client-7.png";
import client_8 from "./assets/client/client-8.png";
import client_9 from "./assets/client/client-9.png";
import client_10 from "./assets/client/client-10.png";
import client_11 from "./assets/client/client-11.png";
import client_12 from "./assets/client/client-12.png";
import client_13 from "./assets/client/client-13.png";
import banner1 from "./assets/banners/banner-1.png";
import banner2 from "./assets/banners/banner-2.png";
import banner3 from "./assets/banners/banner-3.png";
import banner_1 from "./assets/banners/banner_1.png";
import banner_2 from "./assets/banners/banner_2.png";
import banner_3 from "./assets/banners/banner_3.png";
import banner_4 from "./assets/banners/banner_4.png";
import product1 from "./assets/card/product-1.png";
import product2 from "./assets/card/product-2.png";
import tick from "./assets/logo/tick.svg";
import services1 from "./assets/banners/services-1.png";
import services2 from "./assets/banners/services-2.png";
import services3 from "./assets/banners/services-3.png";
import services4 from "./assets/banners/services-4.png";
import services5 from "./assets/banners/services-5.jpg";
import services6 from "./assets/banners/services-6.jpg";
import services7 from "./assets/banners/certificate.png";
import ourWork1 from "./assets/banners/our-work-1.png";
import ourWork2 from "./assets/banners/our-work-2.png";
import ourWork3 from "./assets/banners/diaries.jpg";
import ourWork4 from "./assets/banners/our-work-4.jpg";
import ourWork5 from "./assets/banners/our-work-5.png";
import ourWork6 from "./assets/banners/our-work-6.png";
import ourWork7 from "./assets/banners/our-work-7.png";
import ourWork8 from "./assets/banners/our-work-8.png";
import ourWork9 from "./assets/banners/our-work-9.png";
import ourWork10 from "./assets/banners/our-work-10.png";
import ourWork11 from "./assets/banners/our-work-11.png";
import ourWork12 from "./assets/banners/our-work-12.png";
import ourWork13 from "./assets/banners/our-work-13.png";
import ourWork14 from "./assets/banners/our-work-14.png";
import ourWork15 from "./assets/banners/business-card.jpg";
import ourWork16 from "./assets/banners/social-media.jpeg";
import ourWork17 from "./assets/banners/letterheads-envelopes.png";
import ourWork18 from "./assets/banners/posters-pamphlets.jpeg";
import ourWork19 from "./assets/banners/magazines.png";
import ourWork20 from "./assets/banners/calendars-notepads.jpeg";
import ourWork21 from "./assets/banners/Designer-Wedding-Card-Transparent-File.png";
import ourWork22 from "./assets/banners/menu-card.jpeg";
import ourWork23 from "./assets/banners/roll-up-standees.jpg";
import ourWork24 from "./assets/banners/shop-boards.jpeg";
import ourWork25 from "./assets/banners/pen.png";
import ourWork26 from "./assets/banners/tech-gifts.jpeg";
import ourWork27 from "./assets/banners/our-work-27.png";
import ourWork28 from "./assets/banners/logo.jpg";
import ourWork29 from "./assets/banners/product-catalogue.avif";
import ourWork30 from "./assets/banners/company-profiles.webp";
import ourWork31 from "./assets/banners/brochures-leaflets.png";
import ourWork32 from "./assets/banners/diaries-calenders.jpeg";
import ourWork33 from "./assets/banners/news-letters-annual-reports.avif";
import ourWork34 from "./assets/banners/school-college-magzines.jpg";
import ourWork35 from "./assets/banners/customised-file-folders.png";
import ourWork36 from "./assets/banners/led-board-2D-3D-Boards.png";
import ourWork37 from "./assets/banners/sign-boards-bront-back-light-board.jpg";
import ourWork38 from "./assets/banners/direction-boards.webp";
import ourWork39 from "./assets/card/product-1.png";
import ourWork40 from "./assets/banners/indoor-plants.jpg";
import ourWork41 from "./assets/banners/sweet-cake-boxes.jpg";
import ourWork42 from "./assets/banners/stickers--lables.png";
import ourWork43 from "./assets/banners/spices-confectionery-paper-covers.png";
import ourWork44 from "./assets/banners/gift-boxes.jpg";
import ourWork45 from "./assets/banners/product-catalogues.jpg";
import breadcrumb from "./assets/image/breadcrumb.jpg";
import printProduct from "./assets/image/print_product.jpg";
import blogImg1 from "./assets/image/blog/image.png";
import blogImg2 from "./assets/image/blog/blog1.jpg";
import groupImage from "./assets/image/group-img.png";
import groupImage_2 from "./assets/image/group-img_2.png";
import service_office_stationery from "./assets/image/service/office_stationery.jpg";
import service_keyChain from "./assets/image/service/keychain.png";
import service_meomontoes from "./assets/image/service/meomontoes.jpg";
import service_giftbox from "./assets/image/service/giftbox.jpg";
import service_spices_confectionery_paper_covers from "./assets/image/service/spices_confectionery_paper_covers.jpg";
import service_brochures_leaflets from "./assets/image/service/brochures_leaflets.png";
import service_sandwich_board from "./assets/image/service/sandwich_board.jpg";
import service_stickers_lables from "./assets/image/service/stickers_lables.png";

export const Anulicense = {
    logo,
    groupImage_2,
    banner: bannserImg,
    featureImg1,
    featureImg2,
    featureImg3,
    clientSlider: [client_1, client_2, client_3, client_4, client_5, client_6, client_7, client_8, client_9, client_10, client_11, client_12, client_13],
    banner1,
    banner2,
    banner3,
    product1,
    product2,
    tick,
    service_office_stationery,
    service_keyChain,
    service_meomontoes,
    service_giftbox,
    service_spices_confectionery_paper_covers,
    service_brochures_leaflets,
    service_sandwich_board,
    service_stickers_lables,
    services1,
    services2,
    services3,
    services4,
    services5,
    services6,
    services7,
    ourWork1,
    ourWork2,
    ourWork3,
    ourWork4,
    ourWork5,
    ourWork6,
    ourWork7,
    ourWork8,
    ourWork9,
    ourWork10,
    ourWork11,
    ourWork12,
    ourWork13,
    ourWork14,
    ourWork15,
    ourWork16,
    ourWork17,
    ourWork18,
    ourWork19,
    ourWork20,
    ourWork21,
    ourWork22,
    ourWork23,
    ourWork24,
    ourWork25,
    ourWork26,
    ourWork27,
    ourWork28,
    ourWork29,
    ourWork30,
    ourWork31,
    ourWork32,
    ourWork33,
    ourWork34,
    ourWork35,
    ourWork36,
    ourWork37,
    ourWork38,
    ourWork39,
    ourWork40,
    ourWork41,
    ourWork42,
    ourWork43,
    ourWork44,
    ourWork45,
    groupImage,
    breadcrumb,
    printProduct,
    blogImg1,
    blogImg2,
    banner_1,
    banner_2,
    banner_3,
    banner_4
}